/* ============================================================
   STRUKT — global.js
   Real Shopify interactions: Ajax Cart API, predictive search,
   mega menu, mobile menu, announcement bar, header scroll,
   hero parallax, scroll reveals.
   ============================================================ */
(function () {
  'use strict';

  var doc = document;
  var body = doc.body;
  var routes = window.routes || {};

  function qs(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- scroll reveals ---------- */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-inview');
        io.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px' });
  function watchReveals() {
    qsa('.reveal:not(.is-inview)').forEach(function (el) { io.observe(el); });
  }
  watchReveals();

  /* ---------- header scroll state (sticky, hides on scroll down, reveals on scroll up) ---------- */
  var header = qs('[data-header]');
  if (header) {
    var lastScrollY = window.scrollY;
    var hideThreshold = 80;
    addEventListener('scroll', function () {
      var currentY = window.scrollY;
      header.classList.toggle('is-scrolled', currentY > 12);
      if (currentY > lastScrollY && currentY > hideThreshold) {
        header.classList.add('is-hidden');
      } else if (currentY < lastScrollY) {
        header.classList.remove('is-hidden');
      }
      lastScrollY = currentY;
    }, { passive: true });
  }

  /* ---------- announcement bar rotation ---------- */
  (function () {
    var bar = qs('[data-announcement-bar]');
    if (!bar) return;
    var slides = qsa('[data-announcement-slide]', bar);
    if (slides.length < 2) return;
    var speed = parseInt(bar.dataset.announcementSpeed, 10) || 5000;
    var i = 0;
    setInterval(function () {
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }, speed);
  })();

  /* ---------- mega menu / dropdown (desktop) ---------- */
  qsa('[data-mega-item]').forEach(function (item) {
    var toggle = qs('[data-mega-toggle]', item);
    var timer;
    item.addEventListener('mouseenter', function () {
      clearTimeout(timer);
      item.classList.add('is-open');
    });
    item.addEventListener('mouseleave', function () {
      timer = setTimeout(function () { item.classList.remove('is-open'); }, 180);
    });
    if (toggle) {
      toggle.addEventListener('click', function () { item.classList.toggle('is-open'); });
    }
  });

  /* ---------- shop by category tabs ---------- */
  qsa('[data-category-tab]').forEach(function (tab) {
    tab.addEventListener('click', function () {
      var group = tab.closest('.category-shop');
      if (!group) return;
      qsa('[data-category-tab]', group).forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');
      qsa('[data-category-panel]', group).forEach(function (panel) {
        panel.hidden = panel.dataset.categoryPanel !== tab.dataset.target;
      });
    });
  });

  /* ---------- hero parallax ---------- */
  (function () {
    var media = qs('[data-parallax]');
    if (!media) return;
    var raf;
    addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        if (scrollY < innerHeight * 1.2) {
          media.style.transform = 'translateY(' + scrollY * 0.18 + 'px)';
        }
        raf = null;
      });
    }, { passive: true });
  })();

  /* ---------- mobile menu ---------- */
  (function () {
    var menu = qs('[data-mobile-menu]');
    if (!menu) return;
    var openBtn = qs('[data-mobile-open]');
    if (openBtn) {
      openBtn.addEventListener('click', function () {
        menu.classList.add('is-open');
        menu.setAttribute('aria-hidden', 'false');
        body.style.overflow = 'hidden';
      });
    }
    qsa('[data-mobile-close]', menu).forEach(function (el) {
      el.addEventListener('click', function () {
        menu.classList.remove('is-open');
        menu.setAttribute('aria-hidden', 'true');
        body.style.overflow = '';
      });
    });
    qsa('[data-mobile-sub-toggle]', menu).forEach(function (t) {
      t.addEventListener('click', function () {
        var item = t.closest('[data-mobile-sub]');
        var willOpen = !item.classList.contains('is-open');
        /* one accordion open at a time, like a clean app menu */
        qsa('[data-mobile-sub].is-open', menu).forEach(function (other) { other.classList.remove('is-open'); });
        if (willOpen) item.classList.add('is-open');
      });
    });
  })();

  /* ================= Cart (real Shopify Ajax API) ================= */
  var THRESHOLD = (window.theme && window.theme.freeShippingThreshold) || 0;

  var toastEl;
  function showToast(msg) {
    if (!toastEl) {
      toastEl = doc.createElement('div');
      toastEl.className = 'toast';
      body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    requestAnimationFrame(function () { toastEl.classList.add('is-visible'); });
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2200);
  }

  function updateCartCount(count) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
      el.classList.add('is-bumped');
      setTimeout(function () { el.classList.remove('is-bumped'); }, 350);
    });
  }

  function openCart() {
    var drawer = qs('[data-cart-drawer]');
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    body.style.overflow = 'hidden';
  }
  function closeCart() {
    var drawer = qs('[data-cart-drawer]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    body.style.overflow = '';
  }

  function refreshCartDrawer(openAfter) {
    return fetch('/?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc2 = new DOMParser().parseFromString(html, 'text/html');
        var newDrawer = doc2.querySelector('[data-cart-drawer]');
        var oldDrawer = qs('[data-cart-drawer]');
        if (newDrawer && oldDrawer) {
          oldDrawer.replaceWith(newDrawer);
        }
        if (openAfter) openCart();
      });
  }

  function refreshCartCount() {
    return fetch((routes.cart_url || '/cart') + '.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); return cart; });
  }

  function addToCart(variantId, btn) {
    if (!variantId) return;
    if (btn) btn.disabled = true;
    fetch((routes.cart_add_url || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          showToast(data.description || 'Could not add that to your cart.');
          return;
        }
        return Promise.all([refreshCartCount(), refreshCartDrawer(true)]).then(function () {
          showToast('Added to cart');
        });
      })
      .catch(function () { showToast('Something went wrong. Please try again.'); })
      .finally(function () { if (btn) btn.disabled = false; });
  }

  function updateLine(line, quantity) {
    fetch((routes.cart_change_url || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return Promise.all([refreshCartCount(), refreshCartDrawer(true)]); })
      .catch(function () { showToast('Something went wrong. Please try again.'); });
  }

  doc.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-quick-add]');
    if (addBtn && !addBtn.disabled) {
      e.preventDefault();
      addToCart(addBtn.dataset.variantId, addBtn);
      return;
    }
    var openBtn = e.target.closest('[data-cart-open]');
    if (openBtn) { e.preventDefault(); openCart(); return; }

    var closeBtn = e.target.closest('[data-cart-close]');
    if (closeBtn) { e.preventDefault(); closeCart(); return; }

    var qtyBtn = e.target.closest('[data-cart-qty]');
    if (qtyBtn) {
      e.preventDefault();
      var input = qtyBtn.closest('.qty').querySelector('.qty__input');
      var delta = parseInt(qtyBtn.dataset.cartQty, 10) || 0;
      var newQty = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
      updateLine(qtyBtn.dataset.line, newQty);
      return;
    }

    var rmBtn = e.target.closest('[data-cart-remove]');
    if (rmBtn) {
      e.preventDefault();
      updateLine(rmBtn.dataset.line, 0);
      return;
    }
  });

  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeCart(); closeSearch(); }
  });

  window.addEventListener('strukt:toast', function (e) { showToast(e.detail); });

  /* ================= Predictive search ================= */
  var searchModal = qs('[data-search-modal]');
  var searchAbort;

  function openSearch() {
    if (!searchModal) return;
    searchModal.classList.add('is-open');
    searchModal.setAttribute('aria-hidden', 'false');
    var input = qs('[data-search-input]', searchModal);
    if (input) input.focus();
  }
  function closeSearch() {
    if (!searchModal) return;
    searchModal.classList.remove('is-open');
    searchModal.setAttribute('aria-hidden', 'true');
  }
  qsa('[data-search-open]').forEach(function (b) { b.addEventListener('click', openSearch); });
  if (searchModal) {
    qsa('[data-search-close]', searchModal).forEach(function (b) { b.addEventListener('click', closeSearch); });
  }
  doc.addEventListener('keydown', function (e) {
    if ((e.metaKey || e.ctrlKey) && e.key === 'k') { e.preventDefault(); openSearch(); }
  });

  function renderSearchResults(products, query) {
    var out = qs('[data-search-results]');
    if (!out) return;
    if (!products.length) {
      out.innerHTML = '<div class="predictive-results__none"><p>No results for &ldquo;' + escapeHtml(query) + '&rdquo;.</p></div>';
      return;
    }
    out.innerHTML = '<ul class="predictive-results__products" role="list" style="list-style:none">' + products.map(function (p) {
      var compare = '';
      if (p.compare_at_price_min && p.compare_at_price_min !== p.price_min) {
        compare = ' <s>' + escapeHtml(p.compare_at_price_min) + '</s>';
      }
      return '<li><a href="' + p.url + '" class="predictive-item" data-search-result>' +
        '<img src="' + p.image + '&width=120" alt="" width="56">' +
        '<span class="predictive-item__info">' +
        (p.type ? '<span class="predictive-item__category label-xs">' + escapeHtml(p.type) + '</span>' : '') +
        '<span class="predictive-item__title">' + escapeHtml(p.title) + '</span>' +
        '<span class="predictive-item__price">' + escapeHtml(p.price_min) + compare + '</span>' +
        '</span></a></li>';
    }).join('') + '</ul>';
    qsa('[data-search-result]', out).forEach(function (a) { a.addEventListener('click', closeSearch); });
  }

  var searchInput = qs('[data-search-input]');
  if (searchInput && routes.predictive_search_url) {
    var debounceTimer;
    searchInput.addEventListener('input', function () {
      var q = this.value.trim();
      var out = qs('[data-search-results]');
      clearTimeout(debounceTimer);
      if (q.length < 2) {
        if (out) out.innerHTML = '';
        return;
      }
      debounceTimer = setTimeout(function () {
        if (searchAbort) searchAbort.abort();
        searchAbort = new AbortController();
        var url = routes.predictive_search_url + '?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url, { signal: searchAbort.signal })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            renderSearchResults(products, q);
          })
          .catch(function (err) { if (err.name !== 'AbortError') showToast('Search is unavailable right now.'); });
      }, 220);
    });
  }
})();
